// extracted by mini-css-extract-plugin
module.exports = {"Container":"Counter_Container__3dVLn","Input":"Counter_Input__1TcBi","ControlIcon":"Counter_ControlIcon__35AZk","right":"Counter_right__2Vxe-","left":"Counter_left__60fdy"};